module.exports = "<svg viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.396 7.396c.478.478 1.252.482 1.735.008l5.39-5.294A1.232 1.232 0 0 0 11.792.353L7.257 4.788 2.853.36A1.232 1.232 0 1 0 1.11 2.103l5.286 5.294z\" fill=\"#E1EEF4\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/caret-icon.svg
// module id = 75Yw
// module chunks = 89